<template>
    <div class="row">
        <div class="col-md-3">
            <filter-tree
                    :initial_filter="[
                {'type':27, 'value':''},
                {'type':23, 'value':'No'},
                {'type':9, 'value':'No'},
                {'type':11, 'value':'No'},
                {'type':7, 'value':''}
               ]"
                    @update="update"
                    @load="load" :max_results="max_results"></filter-tree>
        </div>
        <div class="col-md-9">

            <div>
                <asset-grid @update_selection_asset_ids="update_selection_asset_ids" @reload="load" :items="items"></asset-grid>
            </div>
        </div>
    </div>
</template>

<script>
  import FilterTree from "@/components/asset_filter/FilterTree";
  import AssetGrid from "@/components/AssetGrid";
  import LoadLabelsMixin from "@/mixins/LoadLabelsMixin";
  export default {
    name: "FilterAssetWithPreview",
    mixins: [LoadLabelsMixin],
    components: {AssetGrid, FilterTree},
    data () {
      return {
        'items': [],
        'max_results': 12,
        'base_colors': [
        [249, 65, 68],
        [243, 114, 44],
        [248, 150, 30],
        [67, 170, 139],
        [249, 132, 74],
        [249, 199, 79],
        [144, 190, 109],
        [77, 144, 142],
        [87, 117, 144],
        [39, 125, 161],
        [249, 65, 68],
        [243, 114, 44],
        [248, 150, 30],
        [67, 170, 139],
      ]
      }
    },
    methods: {
      update_selection_asset_ids(asset_ids) {
        this.$emit('update_selection_asset_ids', asset_ids)
      },
      update (filters) {
        this.$emit('update_filter', filters)
      },
      async load(filters, limit) {
        this.$emit('update_filter', filters)

        if(!filters) {
          filters = this.filters
          limit = this.limit
        }

        let items = await this.$api.asset.filter(filters, limit)
        let this2 = this;
        this.$api.asset.count_filter(filters).then((count) => {
          this2.$set(this2, 'max_results', count);
        });
        this.$emit('loaded')

        if (items.length === 0) {
          this.$set(this,'loading',false);
          this.$set(this, 'max_results', 0);
        }


        items.map((item) => {
        try {
          item.annotations = item.relationships.annotations.map((annotation) => {
            let label = this.labels.find((label) => {
              return label.id === annotation.label_id
            });

      
            annotation.label = label;
            annotation.coords = JSON.parse(annotation.coords);
            if(label.color) {
              annotation.color_values = label.color.split(',')
            }
            else {
              let random_color = this.base_colors[Math.floor(Math.random() * this.base_colors.length)];
              annotation.color_values = random_color;
            }
            
            annotation.type = annotation.type === 1 ? 'box' : 'point'
            annotation.label = label.name;
            annotation.conf = annotation.certainty === null ? 1 : annotation.certainty;
            return annotation
          });
        } catch (error) {
          console.log(error);
          item.annotations = [];
        }

        item.checked = true
        item.path = this.$api_host + '/' + item.static_path
      });
      this.$set(this, 'items', items);
      }
    }
  }
</script>

<style scoped>

</style>